import { Outlet } from 'react-router-dom';
import './UnauthentifiedLayout.scss';
import { Container } from '@design-system/components/Container/Container';

export const UnauthentifiedLayout = () => (
    <>
        <Container className="unauthentified-layout layout" padding="large">
            <Container className="rendered-page" padding="none">
                <Outlet />
            </Container>
        </Container>
    </>
);

export default UnauthentifiedLayout;
